import React from 'react'
import { IClusterStatus } from './model'
import { isEmpty } from 'ramda'
import { memoize } from 'utils/misc'
import { BadgeVariant } from 'core/elements/badge/Badge'
import { DateAndTime } from 'core/components/listTable/cells/DateCell'
import ClusterStatusSpan from './ClusterStatusSpan'

export const getPodsMounted = memoize((pvc, allPods = []) => {
  const pods = allPods.filter(
    (pod) =>
      !!pod?.spec?.volumes?.find((vol) => vol?.persistentVolumeClaim?.claimName === pvc?.name),
  )
  if (isEmpty(pods)) return []

  // Get mount paths for all containers in all pods
  const mounts = []
  for (const pod of pods) {
    const containers = pod?.spec?.containers || []
    const volumes = pod?.spec?.volumes || []
    const volumesMap = {}
    volumes.forEach((v) => {
      volumesMap[v?.name] = v
    })
    for (const container of containers) {
      const volumeMounts = container?.volumeMounts || []
      for (const vm of volumeMounts) {
        if (volumesMap[vm?.name]?.persistentVolumeClaim?.claimName) {
          mounts.push({
            pod: pod?.name,
            container: container?.name,
            path: vm?.mountPath,
          })
        }
      }
    }
  }
  return mounts
})

export const renderPvcStatus = (phase) => {
  let status: IClusterStatus = 'ok'
  switch (phase) {
    case 'Available':
    case 'Bound':
      status = 'ok'
      break
    case 'Released':
      status = 'pause'
      break
    case 'Pending':
      status = 'pending'
      break
    case 'Lost':
      status = 'fail'
      break
    case 'Failed':
      status = 'fail'
      break
  }
  return (
    <ClusterStatusSpan title={phase} status={status} data-testid={`pvc-status-${phase}`}>
      {phase}
    </ClusterStatusSpan>
  )
}

export const getPvcStatus = (phase) => {
  let status: BadgeVariant = 'success'
  switch (phase) {
    case 'Available':
    case 'Bound':
      status = 'success'
      break
    case 'Released':
      status = 'unknown'
      break
    case 'Pending':
      status = 'warning'
      break
    case 'Failed':
      status = 'error'
      break
  }
  return { variant: status }
}

export const sortByTransitionTime = (a, b) => {
  const x = a?.lastTransitionTime
  const y = b?.lastTransitionTime

  if (x > y) {
    return -1
  }
  if (y > x) {
    return 1
  }
  return 0
}

export const conditionsColumns = [
  {
    key: 'type',
    label: 'Type',
  },
  {
    key: 'status',
    label: 'Status',
  },
  { key: 'message', label: 'Message' },
  { key: 'lastTransitionTime', label: 'Last Transition Time', CellComponent: DateAndTime },
  { key: 'lastHeartbeatTime', label: 'Last Heartbeat Time', CellComponent: DateAndTime },
  { key: 'reason', label: 'Reason' },
]
